// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTADocumentContent } from './dta-document-content';
import {
    DTADocumentContentFromJSON,
    DTADocumentContentFromJSONTyped,
    DTADocumentContentToJSON,
    DTADocumentContentToJSONTyped,
} from './dta-document-content';
import type { SourceType } from './source-type';
import {
    SourceTypeFromJSON,
    SourceTypeFromJSONTyped,
    SourceTypeToJSON,
    SourceTypeToJSONTyped,
} from './source-type';

/**
 * 
 * @export
 * @interface CreateDtaRequest
 */
export interface CreateDtaRequest {
    /**
     * 
     * @type {DTADocumentContent}
     * @memberof CreateDtaRequest
     */
    document_content?: DTADocumentContent;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDtaRequest
     */
    domains?: Array<string>;
    /**
     * 
     * @type {SourceType}
     * @memberof CreateDtaRequest
     */
    source_type: SourceType;
    /**
     * 
     * @type {string}
     * @memberof CreateDtaRequest
     */
    upload_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDtaRequest
     */
    vendor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDtaRequest
     */
    vendor_name?: string;
}



/**
 * Check if a given object implements the CreateDtaRequest interface.
 */
export function instanceOfCreateDtaRequest(value: object): value is CreateDtaRequest {
    if (!('source_type' in value) || value['source_type'] === undefined) return false;
    return true;
}

export function CreateDtaRequestFromJSON(json: any): CreateDtaRequest {
    return CreateDtaRequestFromJSONTyped(json, false);
}

export function CreateDtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'document_content': json['document_content'] == null ? undefined : DTADocumentContentFromJSON(json['document_content']),
        'domains': json['domains'] == null ? undefined : json['domains'],
        'source_type': SourceTypeFromJSON(json['source_type']),
        'upload_id': json['upload_id'] == null ? undefined : json['upload_id'],
        'vendor_id': json['vendor_id'] == null ? undefined : json['vendor_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
    };
}

export function CreateDtaRequestToJSON(json: any): CreateDtaRequest {
    return CreateDtaRequestToJSONTyped(json, false);
}

export function CreateDtaRequestToJSONTyped(value?: CreateDtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_content': DTADocumentContentToJSON(value['document_content']),
        'domains': value['domains'],
        'source_type': SourceTypeToJSON(value['source_type']),
        'upload_id': value['upload_id'],
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
    };
}
